import type { ComputedRef, Ref, UnwrapRef, InjectionKey } from 'vue';

export type TabsPaneContext = UnwrapRef<{
  uid: number;
  disabled: boolean;
  paneName: ComputedRef<string | number | undefined>;
  active: ComputedRef<boolean>;
  index: Ref<string | undefined>;
}>;

export const symbolTabsRootKey: InjectionKey<{
  props: Readonly<any>;
  currentName: Ref<string | number>;
  addChild: (pane: TabsPaneContext) => void;
  removeChild: (uid: number) => void;
}> = Symbol('symbolTabsRootKey');
